import { IScript } from '../interface/script.interface';
import { hotjarScript } from '../scripts/hotjar.script';

export const scriptStore: IScript[] = [hotjarScript];
